import { Col, Menu, Row } from 'antd';
import { Link } from "react-router-dom";
import  LogoContainer  from '../../vodin_logo/container/vodin_logo_container';

export interface TopMenuViewProps{
    leftmenuItems:any[][];
    rightmenuItems:any[][];
    isDropdownOpen:boolean;
    isFullscreenEnabled:boolean;
    onMenuItemClickedCb:(item:string) => void;
    onSwitchFullscreen:(enable:boolean) => void;
}

/**
 * Baut die Eintraege der linken Leiste.
 *
 * antd 6 nimmt das Menue ueber `items` entgegen. "#" als Beschriftung stand
 * bisher fuer einen Trenner; in der Datenform ist das `type: 'divider'`.
 */
function linkeEintraege(props: TopMenuViewProps) {
    return props.leftmenuItems.map((item: any[], index: number) => {
        if (item[1] === "#") {
            return { key: 'trenner-' + index, type: 'divider' as const };
        }

        return {
            key: item[0] + index,
            icon: item[2],
            label: <Link to={item[0]}>{item[1]} </Link>,
            onClick: () => { props.onMenuItemClickedCb(item[0]); },
        };
    });
}

/**
 * Baut die Eintraege der rechten Leiste.
 *
 * Ein Eintrag mit leerem item[3] ist ein einfacher Verweis, sonst ein
 * Untermenue - frueher <SubMenu>, jetzt ein Eintrag mit `children`.
 */
function rechteEintraege(props: TopMenuViewProps) {
    return props.rightmenuItems.map((item: any[], index: number) => {
        if (item[3] === "") {
            return {
                key: item[0] + index,
                icon: item[2],
                style: { margin: "0px 0px", padding: "0px 0px", height: "40px", color: "rgba(248, 249, 250,1)" },
                label: <Link to={item[0]}>{item[1]} </Link>,
            };
        }

        return {
            key: item[0] + index,
            icon: item[2],
            label: item[1],
            children: item[3].map((subitem: any[], subindex: number) => ({
                key: subitem[0] + subindex,
                icon: subitem[2],
                style: { color: "rgba(149,46,66,1)" },
                label: (
                    <Link style={{ color: "rgba(149,46,66,1)" }} to={subitem[0]}> {subitem[1]}</Link>
                ),
            })),
        };
    });
}

 
export function TopMenuView(props:TopMenuViewProps){
    return (
        <Row justify="space-between">
            <Col span={8}>
    <div style={{display:"flex",flexFlow:"row nowrap",  justifyContent:"space-between"}}></div>
        <div style={{display:"flex", flexFlow:"row nowrap"}}></div>
        <Menu mode="horizontal" className="KopfMenue" items={linkeEintraege(props)} />
            </Col>
            <Col span={8} >
                <Row>
                <Col span={8}>
                    </Col>
                <Col span={8}>
                    <LogoContainer/>
                </Col>
                <Col span={8}>
                    </Col>
                    </Row>
            </Col>
            <Col span={8}>
            <Row>
                <Col span={14}>
                    </Col>
                    <Col span={10}>
            <Menu mode="horizontal" className="KopfMenue KopfMenue-rechts" items={rechteEintraege(props)} />
        </Col>
        </Row>
    </Col>
    </Row>
    )

}